import { Link } from 'react-router-dom'
import { WarningIcon } from '~/@mid_ui/icons/WarningIcon'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'

/**
 * Dočasný info banner počas presunu dát z pôvodného systému (split DB, 21.10.2026).
 * Investor zatiaľ nevidí staršie investície/transakcie/dokumenty a z legacy zostatku
 * sa nedá investovať. Po dokončení presunu banner odstrániť z `TopBanners`.
 */
export function DataMigrationBanner() {
  return (
    <div className="flex w-full min-h-12 px-5 py-3 border-b border-black/20 bg-[#FFCA61]">
      <PageContainer className="flex flex-row items-center w-full px-0 md:px-3 font-semibold">
        <div className="flex flex-row items-center gap-2 sm:gap-3">
          <WarningIcon
            className="hidden md:block shrink-0 text-[#121212]"
            width={24}
            height={24}
          />
          <span className="text-black">
            Na platforme momentálne prebieha presun údajov z pôvodného systému.
            Staršie investície, transakcie a dokumenty z neho sa preto zatiaľ
            nemusia zobrazovať. Avšak zostatok z pôvodného systému je započítaný
            v peňaženke a dá sa aj preinvestovať. Ďakujeme za trpezlivosť. V
            prípade otázok nás kontaktujte na{' '}
            <Link
              to="mailto:info@investinslovakia.eu"
              className="text-accent underline text-nowrap">
              info@investinslovakia.eu
            </Link>
            .
          </span>
        </div>
      </PageContainer>
    </div>
  )
}
